module.exports = __webpack_public_path__ + "static/media/се.794879a1.mp3";